import React from 'react'
import FilterDropdown from './FilterDropdown'
import FilterPanelFooter from './FilterPanelFooter'
import MultiSelectFilterOptions, {
   getSelectedValues,
} from './MultiSelectFilterOptions'

/**
 * Desktop multi-select filter dropdown, e.g. for brands or product types.
 * Takes the same option props as MultiSelectFilterOptions plus a toggle `label` and the current `totalCount`.
 */
const MultiSelectFilterDropdown = ({
   fieldName,
   label,
   filters,
   options,
   totalCount,
   updateFilters,
   sortAlphabetically = true,
   ...optionProps
}) => {
   const selectedValues = getSelectedValues(filters, fieldName)

   if (!options?.length && !selectedValues.length) {
      return null
   }

   return (
      <FilterDropdown
         label={label}
         badgeCount={selectedValues.length}
         isActive={selectedValues.length > 0}
         panelWidth="340px"
      >
         {({ close }) => (
            <>
               <MultiSelectFilterOptions
                  fieldName={fieldName}
                  filters={filters}
                  options={options}
                  updateFilters={updateFilters}
                  sortBy={sortAlphabetically ? 'label' : 'none'}
                  autoFocus
                  {...optionProps}
               />
               <FilterPanelFooter
                  onClear={() => updateFilters?.([{ fieldName, value: null }])}
                  clearDisabled={!selectedValues.length}
                  onSubmit={close}
                  totalCount={totalCount}
               />
            </>
         )}
      </FilterDropdown>
   )
}

export default MultiSelectFilterDropdown
